import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as instrumentListActions from './../../actions/instrumentListActions';
import * as dashboardActions from './../../actions/dashboardActions';
import * as tradepanelActions from './../../actions/tradepanelActions';
import * as commonActions from './../../actions/commonActions';
import * as authActions from '../../redux/modules/auth';
var styles = require('./InstrumentList.less');
//import styles from './InstrumentList.less';
import config from './../../config';
import md5 from 'blueimp-md5';
import moment from 'moment';
import appConstants from './../../appConstants';
const elementsData = [
  {"classNames":"instLstTd", "elementType":"normal", "applyTo":"all", "tagNames":"td"},
  {"classNames":"listRow", "elementType":"normal", "applyTo":"alternative", "tagNames":"tr"}
];
let popupwindow; let isopen = true;

@connect(
  state => ({
    layout:state.dashboardRoot.dashboardReducer.layout,
    dashboardWidgets:state.dashboardRoot.dashboardReducer.dashboardWidgets,
    deleteWidgetKey:state.dashboardRoot.dashboardReducer.deleteWidgetKey,
	  socketData:state.dashboardRoot.instrumentListReducer.socketData,
	  openedWidgets:state.dashboardRoot.commonReducer.openedWidgets,
    check:state.dashboardRoot.instrumentListReducer.check,
    cmdt:state.dashboardRoot.instrumentListReducer.cmdt,
    userDetail:state.auth.userDetail,
    // selectedCssColorTheme:state.dashboardRoot.commonReducer.selectedCssColorTheme,
    ratesStatus:state.dashboardRoot.instrumentListReducer.status,
    orderStatus:state.dashboardRoot.tradepanelReducer.orderStatus,
  }),
  { ...instrumentListActions, ...dashboardActions, ...tradepanelActions, ...commonActions, ...authActions})

export default class InstrumentComponent extends Component {
  static propTypes = {
    socketData:PropTypes.array,
    cmdt:PropTypes.string,
    CloseIcon:PropTypes.object,
    keyValue:PropTypes.string.isRequired,
    deleteWidget:PropTypes.func,
    showPreview:PropTypes.object,
    popoutIcon:PropTypes.object,
    popupwindowHandle:PropTypes.func,
    closeSocketData:PropTypes.func,
    loadSocketData:PropTypes.func,
    openedWidgets:PropTypes.array,
    popinWidget:PropTypes.func,
    check:PropTypes.string,
  }

  state = {
    cmdtyData:[]
  }

  constructor() {
    super();
  }

  componentDidMount() {
    this.setState({cmdtyData:this.props.cmdtyrow});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.cmdtyrow !== this.props.cmdtyrow) {
      this.setState({cmdtyData:nextProps.cmdtyrow});
    }
    if (nextProps.check !== this.props.check) {
      this.setState({cmdtyData:nextProps.socketData.get(this.state.cmdtyData.I)});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.check !== this.props.check) {
      return true;
    }
    if (nextProps.cmdtyrow !== this.props.cmdtyrow) {
      return true;
    }
    if (nextState.cmdtyData !== this.state.cmdtyData) {
      return true;
    }
    if (nextProps.width !== this.props.width) {
      return true;
    }
    return false;
  }

  render() {
    const { cmdtyData} = this.state;
    // const detailedInstList=JSON.parse(localStorage.getcmdtyData('TS')).isDetailedInstList;
    const selectedfont_size='fontSize_'+this.props.userDetail.fontSize;
    // let fontColorBid = 'black';
    // let fontColorAsk = 'black';
    let fontColorHigh = 'black';
    let fontColorLow = 'black';
    // if (cmdtyData.variationInBid) {
    //   fontColorBid = cmdtyData.variationInBid === 'increment' ? config.increaseRateColor : config.decreaseRateColor;
    // }
    // if (cmdtyData.variationInAsk) {
    //   fontColorAsk = cmdtyData.variationInAsk === 'increment' ? config.increaseRateColor : config.decreaseRateColor;
    // }
    //console.log("={cmdtyData.STATUS "+ (cmdtyData.STATUS));
    return (
      <tr className={this.props.ratesStatus !== 0 ? `${styles.listRow} listRow` : cmdtyData.STATUS === 2 ?  this.props.width > 1 ? `${styles.listRow} listRow prvdrDown`:`${styles.listRow}  ${styles.instListRow} listRow prvdrDown` : this.props.width > 1 ? `${styles.listRow} listRow` : `${styles.listRow} ${styles.instListRow} listRow`} key={this.props.index}>
        <td className={`${styles.listColumn} ${selectedfont_size} `} >{cmdtyData.cmdty}</td>

        {cmdtyData.variationInBid ?
          <td className={this.props.userDetail.showPrice === "ASK" ? `${styles.listColumn} ${selectedfont_size}`:cmdtyData.variationInBid === 'increment' ? `${styles.increaseRateColor} ${styles.listColumn} ${selectedfont_size} increaseRateColor ` : `${styles.decreaseRateColor} ${styles.listColumn} ${selectedfont_size} decreaseRateColor`}>
            {this.props.userDetail.showPrice !== "ASK" && (cmdtyData.bid) > 0 ? Number(cmdtyData.bid).toLocaleString(navigator.language, {minimumFractionDigits: cmdtyData.dec}) : '- - -'}
          </td>
        :
          <td className={`${styles.listColumn} ${styles.fontBlack} ${selectedfont_size}`} >
            {this.props.userDetail.showPrice !== "ASK" && (cmdtyData.bid) > 0 ? Number(cmdtyData.bid).toLocaleString(navigator.language, {minimumFractionDigits: cmdtyData.dec}) : '- - -'}
          </td>
        }

        {cmdtyData.variationInAsk ?
          <td className={this.props.userDetail.showPrice === "BID" ? `${styles.listColumn} ${selectedfont_size}`:cmdtyData.variationInAsk === 'increment' ? `${styles.increaseRateColor} ${styles.listColumn} ${selectedfont_size} increaseRateColor `: `${styles.decreaseRateColor} ${styles.listColumn} ${selectedfont_size} decreaseRateColor`}>
            {this.props.userDetail.showPrice !== "BID" && (cmdtyData.ask) > 0 ? Number(cmdtyData.ask).toLocaleString(navigator.language, {minimumFractionDigits: cmdtyData.dec}) : '- - -'}
          </td>
        :
          <td className={`${styles.listColumn} ${styles.fontBlack} ${selectedfont_size}`} >
            {this.props.userDetail.showPrice !== "BID" && (cmdtyData.ask) > 0 ? Number(cmdtyData.ask).toLocaleString(navigator.language, {minimumFractionDigits: cmdtyData.dec}) : '- - -'}
          </td>
        }

        {this.props.width > 1 ?
          <td className={`${styles.listColumn} ${selectedfont_size} instLstTd`} >
            {(cmdtyData.H) > 0 ? Number(cmdtyData.H).toLocaleString(navigator.language,{ minimumFractionDigits: cmdtyData.dec}) : '- - -'}
          </td>
        : null}

        {this.props.width > 1 ?
          <td className={`${styles.listColumn} ${selectedfont_size} instLstTd`} >
            {(cmdtyData.L) > 0 ? Number(cmdtyData.L).toLocaleString(navigator.language,{ minimumFractionDigits: cmdtyData.dec}) : '- - -'}
          </td>
        : null}
      </tr>
    );
  }
}
